<template>
  <div>
    <main-header :headerPrimaryName="`Coding / Coders ${headerPrimaryName ? '/ ' + headerPrimaryName : ''}`" :headerSecondaryName="headerSecondaryName" />
    <load-content :loading="isReady == false">
      <div class="main-content">
        <router-view @setHeaderPrimaryName="onSetHeaderPrimaryName" @setHeaderSecondaryName="onSetHeaderSecondaryName" />
      </div>
    </load-content>
  </div>
</template>

<script>
import router from '../../router';
import { mapState, mapActions } from 'vuex';
import LoadContent from '../../components/load-content';
import MainHeader from '../../layouts/main-header';

export default {
  data: function() {
    return {
      headerPrimaryName: '',
      headerSecondaryName: null,
      isReady: true
    }
  },

  methods: {
    onSetHeaderPrimaryName: function(value) {
      this.headerPrimaryName = value;
    },

    onSetHeaderSecondaryName: function(value) {
      this.headerSecondaryName = value;
    },
  },

  components: {
    MainHeader,
    LoadContent
  }
};
</script>